import { Fragment } from "react";
import { Link } from "react-router-dom";

function WhoWeHelpHeaderRight({ cards = [] }) {
  const scrollToSection = (e, targetId) => {
    e.preventDefault();
    const section = document.getElementById(targetId);
    section?.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  };

  return (
    <Fragment>
      <div className="crystal-cards-container">
        {cards.map((card) => (
          <Link
            key={card.targetId}
            to={`#${card.targetId}`}
            className="crystal-card"
            onClick={(e) => scrollToSection(e, card.targetId)}
          >
            <div className="crystal-card-header">
              <img
                src={card.icon}
                alt={card.icon_alt}
                className="expectation-card-icon"
              ></img>
              <strong>{card.heading}</strong>
            </div>
            <p className="cristal-card-description">{card.description}</p>
          </Link>
        ))}
      </div>
    </Fragment>
  );
}

export default WhoWeHelpHeaderRight;
